import React from "react";
import styled from "styled-components";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button } from "../../../v2/design-system";
import { theme } from "../../../v2/design-system/theme";

const ActionRow = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  align-items: center;
`;

/**
 * V2 Table pagination when parent state uses 0-based page index for APIs (e.g. pageNo: page).
 */
export function v2PaginationZeroBased({ pageZeroBased, pageSize, total, setPageZeroBased, setPageSize }) {
  return {
    currentPage: pageZeroBased + 1,
    pageSize,
    total,
    onPageChange: (p) => setPageZeroBased(p - 1),
    onPageSizeChange: (size) => {
      setPageSize(size);
      setPageZeroBased(0);
    },
  };
}

/**
 * V2 Table pagination when parent state uses 1-based page index for APIs.
 */
export function v2PaginationOneBased({ pageOneBased, pageSize, total, setPageOneBased, setPageSize }) {
  return {
    currentPage: pageOneBased,
    pageSize,
    total,
    onPageChange: setPageOneBased,
    onPageSizeChange: (size) => {
      setPageSize(size);
      setPageOneBased(1);
    },
  };
}

/** Ghost icon “view” action used across Organization Hub tables. */
export function HubViewRowButton({ ariaLabel, onClick }) {
  return (
    <ActionRow>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        iconOnly
        aria-label={ariaLabel}
        leftIcon={<VisibilityIcon sx={{ fontSize: 20, color: theme.colors.textMuted }} />}
        onClick={onClick}
      />
    </ActionRow>
  );
}
